const redirectSignInEnv = process.env.APP_REDIRECT_SIGNIN;
const redirectSignOutEnv = process.env.APP_REDIRECT_SIGNOUT;
const redirectSignIn = redirectSignInEnv
    ? redirectSignInEnv.split(',').map(url => url.trim())
    : ['https://dev.d1y71d717jdtc2.amplifyapp.com'];

const redirectSignOut = redirectSignOutEnv
    ? redirectSignOutEnv.split(',').map(url => url.trim())
    : ['https://dev.d1y71d717jdtc2.amplifyapp.com'];

const awsConfig = {
    userPoolId: process.env.USER_POOL_ID,
    userPoolClientId: process.env.USER_POOL_CLIENT_ID,
    identityPoolId: process.env.IDENTITY_POOL_ID,
    cognitoDomain: process.env.COGNITO_DOMAIN,
    redirectSignIn,
    redirectSignOut,
    microsoftCognitoProviderName: process.env.MICROSOFT_COGNITO_PROVIDER_NAME,
};

export default awsConfig;
